const CREATE = 'CREATE'
const UPDATE = 'UPDATE'
const DELETE = 'DELETE'

export default {
  CREATE,
  UPDATE,
  DELETE
}
